/* global axios */
import ApiClient from './ApiClient';

class VoiceCallsAPI extends ApiClient {
  constructor() {
    super('voice_calls', { accountScoped: true });
  }

  // payload: { token, phone, direction, status, wavoip_call_id, duration?, from_tag?, profile_picture? }
  log(payload) {
    return axios.post(this.url, payload);
  }

  fetchRecording(messageId) {
    return axios.post(`${this.url}/${messageId}/fetch_recording`);
  }
}

export default new VoiceCallsAPI();
